/* ==========================================================================
   VICTORY PATH — theme.js
   General UI utilities: sticky header, mobile menu, product gallery, qty, variants.
   ========================================================================== */
(function () {
  'use strict';

  window.VP = window.VP || {};

  /* ---------- Money formatting (Shopify) ---------- */
  VP.formatMoney = function (cents, format) {
    format = format || VP.moneyFormat || '€{{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function defaultTo(num, precision, thousands, decimal) {
      precision = isNaN(precision) ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(num) || num == null) return 0;
      num = (num / 100.0).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cts = parts[1] ? decimal + parts[1] : '';
      return dollars + cts;
    }

    var match = format.match(placeholderRegex);
    switch (match && match[1]) {
      case 'amount': value = defaultTo(cents, 2, '.', ','); break;
      case 'amount_no_decimals': value = defaultTo(cents, 0, '.', ','); break;
      case 'amount_with_comma_separator': value = defaultTo(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = defaultTo(cents, 0, '.', ','); break;
      default: value = defaultTo(cents, 2, '.', ',');
    }
    return format.replace(placeholderRegex, value);
  };

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* ---------- Sticky header on scroll ---------- */
    var header = document.querySelector('[data-header]');
    if (header) {
      var onScroll = function () {
        if (window.scrollY > 50) header.classList.add('is-scrolled');
        else header.classList.remove('is-scrolled');
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    /* ---------- Mobile menu toggle ---------- */
    var toggle = document.querySelector('[data-nav-toggle]');
    if (toggle) {
      toggle.addEventListener('click', function () {
        var open = document.body.classList.toggle('menu-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.body.style.overflow = open ? 'hidden' : '';
      });
      document.querySelectorAll('.mobile-menu a').forEach(function (a) {
        a.addEventListener('click', function () {
          document.body.classList.remove('menu-open');
          document.body.style.overflow = '';
        });
      });
    }

    /* ---------- Product media gallery ---------- */
    var gallery = document.querySelector('[data-gallery]');
    if (gallery) {
      var mainImg = gallery.querySelector('[data-gallery-main] img');
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-full');
          var srcset = thumb.getAttribute('data-srcset');
          if (mainImg && src) {
            mainImg.src = src;
            if (srcset) mainImg.srcset = srcset;
          }
          gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    }

    /* ---------- Quantity steppers (generic) ---------- */
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      if (!input) return;
      wrap.querySelectorAll('[data-qty-btn]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = parseInt(btn.getAttribute('data-qty-btn'), 10);
          var val = Math.max(1, (parseInt(input.value, 10) || 1) + dir);
          input.value = val;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    /* ---------- Variant selection on product page ---------- */
    var form = document.querySelector('[data-product-form]');
    if (form && window.VPProductVariants) {
      var variants = window.VPProductVariants;
      var priceEl = document.querySelector('[data-product-price]');
      var idInput = form.querySelector('[name="id"]');
      var atcBtn = form.querySelector('[data-atc]');

      function currentOptions() {
        return Array.prototype.map.call(form.querySelectorAll('[data-option-index]'), function (group) {
          var checked = group.querySelector('input:checked');
          return checked ? checked.value : null;
        });
      }

      function findVariant(opts) {
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
      }

      function updateVariant() {
        var opts = currentOptions();
        var variant = findVariant(opts);
        if (!variant) {
          if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = VP.strings ? 'Nicht verfügbar' : 'Unavailable'; }
          return;
        }
        if (idInput) idInput.value = variant.id;
        if (priceEl) priceEl.innerHTML = VP.formatMoney(variant.price);
        if (atcBtn) {
          if (variant.available) { atcBtn.disabled = false; atcBtn.textContent = atcBtn.getAttribute('data-label'); }
          else { atcBtn.disabled = true; atcBtn.textContent = atcBtn.getAttribute('data-soldout') || 'Ausverkauft'; }
        }
      }

      form.querySelectorAll('[data-option-index] input').forEach(function (input) {
        input.addEventListener('change', updateVariant);
      });
      updateVariant();
    }

    /* ---------- Collection sort ---------- */
    var sort = document.querySelector('[data-sort]');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }
  });
})();
